export default __webpack_public_path__ + "envelop.png?3367df72963d538fbb7349886390ee9b";